var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"row",attrs:{"tag":"ul"}},_vm._l((_vm.keywordData),function(item,i){return _c('b-col',{key:item.name,staticClass:"search-two",attrs:{"cols":"12","md":"3","tag":"li","index":i},on:{"click":function($event){return _vm.getSearchData(i)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }